import { Colors, Img, Lightning, Router } from "@lightningjs/sdk";
import { SecondaryButton } from "../../components/input/Button/SecondaryButton";
import theme from "../../lib/theme";
import { MediaModel } from "../../lib/models";
import configs from "../../lib/configs";
import { MovieCompact } from "../../components/data-display/MovieDetails/MovieCompact";
import { MovieFullScreen } from "../../components/data-display/MovieDetails/MovieFullScreen";

interface MovieSingleTemplateSpec extends Lightning.Component.TemplateSpec {
    Page: {
        Backdrop: object;
        Overlay: object;
        Back: typeof SecondaryButton;
        Movie: typeof MovieCompact | typeof MovieFullScreen;
    };
}

interface MovieSingleTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true;
}

export class MovieSingle
    extends Lightning.Component<MovieSingleTemplateSpec, MovieSingleTypeConfig>
    implements Lightning.Component.ImplementTemplateSpec<MovieSingleTemplateSpec>
{
    _boundEventHandler?: any;

    private static _hasBackBtn = !configs.layout.mediaSingle.showMenu;

    static override _template(): Lightning.Component.Template<MovieSingleTemplateSpec> {
        return {
            collision: true,
            Page: {
                collision: true,
                w: theme.layout.w,
                h: theme.layout.h,
                Backdrop: {
                    w: theme.layout.w,
                    h: theme.layout.h,
                    alpha: 0.01
                },
                Overlay: {
                    w: theme.layout.w,
                    h: theme.layout.h,
                    rect: true,
                    color: Colors(theme.colors.bg.primary).alpha(0.75).get()
                },
                Back: this._hasBackBtn
                    ? {
                          w: 126,
                          y: 60,
                          x: 50,
                          type: SecondaryButton,
                          label: "general.back",
                          icon: "back",
                          signals: {
                              handleHover: "_handleHover",
                              handleClick: "_handleClick"
                          }
                      }
                    : undefined,
                Movie: {
                    type: configs.layout.mediaSingle.fullWidth ? MovieFullScreen : MovieCompact
                }
            }
        };
    }

    readonly Page = this.getByRef("Page")!;
    readonly Backdrop = this.Page.getByRef("Backdrop")!;
    readonly BackButton = this.Page.getByRef("Back")!;
    readonly Movie = this.Page.getByRef("Movie")!;

    override _setup() {
        this._boundEventHandler = this._showPoster.bind(this);
    }

    set data(movie: MediaModel) {
        window.selectedMovie = movie;

        this.application.emit("clearBackground");
        this.application.emit("updateSelectedMovie", movie);

        this.Backdrop.patch({
            texture: Img(
                `${movie.backdropUrl}${configs.appId != "skyvod" ? `?width=${theme.layout.w}` : "/1920x1080_fit.jpg"}`
            ).cover(theme.layout.w, theme.layout.h)
        });
        this.Movie?.patch({
            data: movie
        });
    }

    override _getFocused() {
        return this.Movie;
    }

    override _active() {
        this.Backdrop.on("txLoaded", this._boundEventHandler);
    }

    override _inactive() {
        this.Backdrop.off("txLoaded", this._boundEventHandler);
    }

    override _handleLeft() {
        if (MovieSingle._hasBackBtn) {
            this._setState("BackState");
        } else {
            Router.focusWidget("Menu");
        }
    }

    override _handleUp() {
        if (MovieSingle._hasBackBtn) {
            this._setState("BackState");
        }
    }

    // override _handleBack() {
    //     if (!Router.getHistory().length) return true;
    //     Router.go(Router.getHistory().length * -1);
    // }

    _showPoster() {
        this.Backdrop.setSmooth("alpha", 1);
    }

    static override _states() {
        return [
            class BackState extends this {
                override _getFocused(): any {
                    return this.BackButton;
                }

                override _handleLeft() {}

                override _handleRight() {
                    this._setState("");
                }

                override _handleDown() {
                    this._setState("");
                }

                override _handleEnter() {
                    if (!Router.getHistory().length) return true;
                    Router.back();
                }
            }
        ];
    }
}
